import { useContext } from 'react';
import { ServiceContext } from '../contexts/service-context';

export function useServices() {
  return useContext(ServiceContext);
}
